function typeFilterActions(target) {
  let ddTarget = target;
  if (!this.$data.settings.filtersLocked) {
    this.setFilterVisibility('showTypeFilter');
    this.scrollToFilterSmallScreen(ddTarget);
  }
}
export default typeFilterActions;
